import { normalize } from 'normalizr';
import {
  IIncompleteMemberFromBlacklist,
  IMembersEntries,
} from '../../../members/types';
import { IPicture } from '../../../pictures/types';
import { IApiBlacklistResult } from '../../models/blacklist/blacklist.types';
import { blacklistSchema } from './blacklist.schema';

export const blacklistNormalizer = (
  blacklist: IApiBlacklistResult
): INormalizedBlacklist => normalize(blacklist, blacklistSchema);

export interface INormalizedBlacklist {
  entities: {
    memberBlacklistInfo: { [id: string]: IIncompleteMemberFromBlacklist };
    members: IMembersEntries;
    pictures: { [id: string]: IPicture };
  };
  result: {
    data: string[];
  };
}
